export const SidebarData = [
    {title: 'ID'},
    {title: 'Product'},
    {title: 'Quantity'},
    {title: 'Price'},
    {title: 'Size'},
    {title: 'Date'},
    // {title: 'Color'},
    {title: 'Status'},
    {title: 'Actions'}
]